import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewNovFinnegans = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'nov_finnegans',
        name: 'NOV_FINNEGANS',
        component: ViewNovFinnegans,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
